/* eslint-disable react/prop-types */
import React from "react"

import * as S from "./style"
import { pushToDataLayer } from "../../helpers/gtmManager"

export const getSizeProps = size => {
  const defaultData = {
    height: 40,
    fontSize: 0.75
  }

  if (!size) return defaultData

  switch (size) {
    case "small": {
      return defaultData
    }
    case "medium":
      return {
        width: 148,
        height: 48,
        fontSize: 0.75
      }
    case "large":
      return {
        width: 250,
        height: 80,
        fontSize: 1.125
      }
    default: {
      return defaultData
    }
  }
}

const LoginButton = ({ label }) => {
  const handleClick = () => {
    pushToDataLayer({ action: "login" })
  }

  return (
    <S.Link to="https://affiliates.betmgmbrazilaffiliates.com.br/affiliates/Account/Login#" onClick={handleClick}>
      {label}
    </S.Link>
  )
}

export default LoginButton
